import React from 'react';
import StepContext from './StepContext';

export default function useStepContext() {
  return React.useContext(StepContext);
}
